import React from "react";
import AsidePhotoList from "../../../camCaptureRecord/components/AsidePhotoList";
import AsideDownload from "../../../download/components/AsideDownload";
import AsideMultiple from "../../../multipleScreen/components/AsideMultiple";
import AsideShift from "../../../shiftBrowser/components/AsideShift";

export default function AsideSubmitted() {
    return (
        <>
            <AsidePhotoList />
            <AsideDownload />
            <AsideMultiple />
            <AsideShift />
        </>
    );
}
